import { Dayjs } from "dayjs";
import { IAppointment } from "../../../../services/api/Appointment/types";

export const isUserStoreManager = (userId: string, storeManagerId: string) =>
  userId === storeManagerId;

